import { RowCrudStatus } from "../../common/types";
import {
  AlertRule,
  AlertRuleCreateMutationVariables,
  AlertRuleUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { safeJsonParse } from "../../../common/utils";

export type AlertRuleValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  alertType: string;
  enabled: boolean;
  params: string;
};

export type AlertRuleErrorsType = {
  alertType?: { message: string; fieldLabel: string };
  enabled?: { message: string; fieldLabel: string };
  params?: { message: string; fieldLabel: string };
};

export function AlertRuleValuesInit(): AlertRuleValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    alertType: "",
    enabled: false,
    params: "{}",
  };
}

export type AlertRuleType = AlertRule | AlertRuleValuesType;

export function alertRuleDisplayId(
  source: Partial<AlertRule>,
  _langStore: LangStore
) {
  return source.alertType ?? _langStore.emptyStringSymbol;
}

export function getAlertRuleValues(
  source: AlertRuleType,
  _langStore: LangStore,
  _duplicated: boolean = false
): AlertRuleValuesType {
  const entityValues = AlertRuleValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : alertRuleDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.alertType = source.alertType;
  entityValues.enabled = source.enabled || false;
  entityValues.params = source.params || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getAlertRuleUpdateVariables(
  values: AlertRuleValuesType
): AlertRuleUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    alertType: values.alertType,
    enabled: values.enabled,
    params: safeJsonParse(values.params, "params"),
  };
}

export function getAlertRuleCreateVariables(
  values: AlertRuleValuesType
): AlertRuleCreateMutationVariables {
  return {
    alertType: values.alertType,
    enabled: values.enabled,
    params: safeJsonParse(values.params, "params"),
  };
}
